import { render, staticRenderFns } from "./DropdownComponent.vue?vue&type=template&id=5edf4f98&scoped=true&"
import script from "./DropdownComponent.vue?vue&type=script&lang=js&"
export * from "./DropdownComponent.vue?vue&type=script&lang=js&"
import style0 from "./DropdownComponent.vue?vue&type=style&index=0&id=5edf4f98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf4f98",
  null
  
)

export default component.exports